export enum PulseClassifiedAdContentInsertionType {
  Manual = 'manual',
  Import = 'import',
}
